import { isString } from 'utils/types'

export const getDimensionStyle = ({
  size,
  doMargins,
  theme,
  verticalMargins,
  horizontalMargins,
  doHeight = true,
}) => {
  const dim = theme.dimensions[size]
  let horzMargin = '0'
  let vertMargin = '0'

  if (doMargins || horizontalMargins) {
    horzMargin = isString(horizontalMargins)
      ? horizontalMargins
      : dim.horzMargin
  }
  if (doMargins || verticalMargins) {
    vertMargin = isString(verticalMargins) ? verticalMargins : dim.vertMargin
  }

  return `
      margin: ${vertMargin} ${horzMargin};
      height: ${doHeight ? dim.height : ''};
      font-size: ${dim.fontSize};
      line-height: ${dim.lineHeight};
      letter-spacing: ${dim.letterSpacing || 'normal'};
  `
}

export const getFontStyle = (theme) => `
  font-family:  ${theme.fonts.family};
  font-weight:  ${theme.fonts.weight};
  font-style:   ${theme.fonts.style};
  font-stretch: ${theme.fonts.stretch};
`

export const getInputBorderStyle = (theme) => `
  border-radius: ${theme.inputBorder.radius};
  border:        ${theme.inputBorder.border};
`
